import { useQuery } from "@tanstack/react-query";
import { countryService } from "../../../../shared/api/countryService";

export const useDefaultCountry = () => {
	const { data, isLoading } = useQuery({
		queryKey: countryService.defaultCountryKey,
		queryFn: () => countryService.getDefaultCountry().then((r) => r.data.data),
	});

	return {
		defaultCountry: data,
		isLoading,
	};
};
